<template>
  <div class="px-gd-1">
    <b-button 
      variant="default" 
      v-b-toggle.collapse-1 
      block
      :disabled="!userPermissions.fileManager.folder.add"
    >
      <i class="far fa-plus"></i> {{ $t('engine.filemanager.createFolder', languageEngine) }}
    </b-button>
    <b-collapse
      id="collapse-1"
      class="mt-gd-1"
      :class="{
        errors: $v.folderName.$error,
      }"
    >
      <b-form-input style="height: 24px;" v-model="$v.folderName.$model"></b-form-input>
      <small v-if="!$v.folderName.required && $v.folderName.$error">
        {{$t('engine.filemanager.createFolder.invalid.nameEmpty',languageEngine)}}
      </small>
      <small v-else-if="!$v.folderName.maxLength && $v.folderName.$error">
        {{$t('engine.filemanager.createFolder.invalid.nameLength', languageEngine)}}
      </small>
      <small v-else-if="!$v.folderName.alpha && $v.folderName.$error">
        {{$t('engine.filemanager.createFolder.invalid.nameFormat', languageEngine)}}
      </small>
      <small v-else-if="!$v.folderName.reservedWord && $v.folderName.$error">
        {{$t('engine.filemanager.createFolder.invalid.nameTaken', languageEngine)}}
      </small>
      <small v-else-if="!$v.folderName.isUnique && $v.folderName.$error">
        {{$t('engine.filemanager.createFolder.invalid.nameTaken', languageEngine)}}
      </small>
      <div>
        <b-button variant="blue" class="mt-gd-1" @click="createdDir()">
          {{ $t('engine.filemanager.createBtn', languageEngine) }}
        </b-button>
      </div>
    </b-collapse>
  </div>
</template>

<script>
import fileService from "@services/fileService.js";
import { required, maxLength, helpers } from "vuelidate/lib/validators";
import { mapGetters } from "vuex";

const alpha = helpers.regex("alpha", /^[a-zA-Z\d_-]+$/i);

const reservedWord = (value) => {
  const reservedWords = ["defaultdata", "0", "download"];
  if (reservedWords.indexOf(value.toLowerCase()) != -1) {
    return false;
  }
  return true;
};

export default {
  data() {
    return {
      folderName: "",
    };
  },
  computed: {
    ...mapGetters({
      languageEngine: "design/userPreference/languageEngine",
      userPermissions: "design/userPreference/permissions",
    }),
  },
  methods: {
    createdDir() {
      this.$v.$touch();
      if (this.$v.$invalid) return;
      fileService
        .addDirectory({ directoryName: this.folderName })
        .then((result) => {
          if (result.id) {
            this.folderName = "";
            this.$v.$reset();
            this.$toast.success({
              title: this.$t(
                "engine.common.alert.success.title",
                this.languageEngine
              ),
              message: this.$t("engine.filemanager.alert.createFolder.success", this.languageEngine),
            });
            this.$emit("callback", { id: result.id, name: result.name });
          } else {
            this.$toast.success({
              title: this.$t(
                "engine.common.alert.error.title",
                this.languageEngine
              ),
              message:this.$t("engine.filemanager.alert.createFolder.fail", this.languageEngine),
            });
          }
        });
    },
  },
  validations: {
    folderName: {
      required,
      maxLength: maxLength(50),
      alpha,
      reservedWord,
      isUnique(value) {
        if (value === "") return true;
        return new Promise((resolve, reject) => {
          setTimeout(() => {
            fileService
              .checkDirValid({ directoryName: value })
              .then((result) => {
                if (result.success) {
                  resolve(true);
                } else {
                  reject(false);
                }
              });
          }, 1000);
        });
      },
    },
  },
};
</script>

<style></style>
